import { useEffect, useState } from "react";
import { useApi } from "utils";
import { FormStateProjectProfile } from "../types/ProfileTypes";

export type SuccessFetch = {
status: string;
responseStatus: number;
message: string;
payload: FormStateProjectProfile[];
};

export function useProfileDetail(id?: string) {
    const api = useApi();
    const [data, setData] = useState<FormStateProjectProfile[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    const fetchData = async () => {
        setLoading(true);
        setError(null);
        try {
            const res = await api.get(`project/get_project_profile_by_project_id`, {
            params: { project_id: id },
            });
            const response: SuccessFetch = res.data;
            setData(response.payload);
            
        } catch (err: any) {
            setError(err?.response?.data?.message || "Failed to fetch data");
            setData([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        // jangan fetch kalau tidak ada id (mode create)
        if (!id) return;
        fetchData();
         // eslint-disable-next-line
    }, [id]);

    return { data, loading, error };
}
